import { SequenceMenu } from '@sequencehq/core-components'

import { FinalizeModal } from 'Invoices/components/CreateEditShared/modals/FinalizeModal'
import { usePermissions } from 'lib/rbac'

export const MenuItemFinalizeInvoice = () => {
  const { can } = usePermissions()

  if (!can('org.invoice:finalize')) {
    return null
  }

  return (
    <FinalizeModal
      trigger={({ onClick, disabled }) => (
        <SequenceMenu.Item
          uuid="finalize-invoice"
          label="Finalize invoice"
          isDisabled={disabled}
          onClick={onClick}
          data-testid="header.kebab-menu.finalize-invoice"
        />
      )}
    />
  )
}
